import React from 'react';

export default function Gloria() {
  return (
    <>
    Gloria al Padre, al Hijo <br/> y al Espíritu Santo. <br/> Como era en el principio, <br/> ahora y siempre, por los siglos de los siglos. <br/> <br/> Amén
    </>
  );
}
